import { render, staticRenderFns } from "./CarouselGalleryZoomer.vue?vue&type=template&id=8655d83a&scoped=true&"
import script from "./CarouselGalleryZoomer.vue?vue&type=script&lang=js&"
export * from "./CarouselGalleryZoomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8655d83a",
  null
  
)

export default component.exports